import styled, { keyframes, css } from 'styled-components';
import { COLORS } from '../Activities/ActivityMenu/styles/constants';

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 800px;
  background-color: ${COLORS.BACKGROUND};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background-color: ${COLORS.BACKGROUND};

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.BORDER_LIGHT};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${COLORS.TEXT_SECONDARY};
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const MessageBubble = styled.div<{ $isOwn: boolean; $isNew?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isOwn }) => ($isOwn ? 'flex-start' : 'flex-end')};
  max-width: 70%;
  margin-left: ${({ $isOwn }) => ($isOwn ? '0' : 'auto')};
  margin-right: ${({ $isOwn }) => ($isOwn ? 'auto' : '0')};
  ${({ $isNew }) =>
    $isNew &&
    css`
      animation: ${fadeIn} 0.3s ease-out;
    `}
`;

export const MessageSender = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  padding: 0 0.5rem;
`;

export const MessageContent = styled.div<{ $isOwn: boolean; $color?: string }>`
  padding: 0.75rem 1rem;
  border-radius: ${({ $isOwn }) =>
    $isOwn ? '1rem 1rem 1rem 0.25rem' : '1rem 1rem 0.25rem 1rem'};
  background-color: ${({ $isOwn, $color, theme }) => {
    if ($isOwn) {
      return theme.colors?.background || COLORS.BACKGROUND;
    }
    return $color || theme.colors?.primary || COLORS.SECONDARY_PALETTE.BLUE;
  }};
  color: ${({ $isOwn }) => ($isOwn ? COLORS.TEXT_PRIMARY : COLORS.TEXT_SECONDARY)};
  font-size: 0.875rem;
  line-height: 1.5;
  word-wrap: break-word;
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  background-color: ${COLORS.BACKGROUND};
  border-top: 1px solid ${COLORS.BORDER_LIGHT};
`;

export const ChatInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  border: 1px solid ${COLORS.BORDER_LIGHT};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: ${COLORS.PRIMARY};
    box-shadow: 0 0 0 3px
      ${COLORS.PRIMARY ? `${COLORS.PRIMARY}20` : `rgba(${COLORS.PRIMARY.replace('#', '')}, 0.1)`};
  }

  &::placeholder {
    color: ${COLORS.TEXT_SECONDARY};
  }
`;

export const MessageTime = styled.div<{ $isOwn: boolean }>`
  font-size: 0.625rem;
  color: ${COLORS.TEXT_SECONDARY};
  margin-top: 0.25rem;
  padding: 0 0.5rem;
`;
